
  import { ListingFilter } from '@loavies/c2c-models'

  export default {
    props: {
      filter: {
        type: ListingFilter,
        required: true,
      },
    },
  }
